import {ActionHandlerBase} from "../action-handler-base";
import {IOpenForgotPasswordActionPayload} from "@sparkware/uc-sdk-core";

export class OpenForgotYourPasswordActionHandler extends ActionHandlerBase<IOpenForgotPasswordActionPayload> {
    async handle(payload: IOpenForgotPasswordActionPayload): Promise<void> {
        if(payload?.actionData?.dontWaitForUserAction) {
            this.services.externalLinks.then((externalLinks) => {
                externalLinks.openForgotPassword();
            });
        } else {
            await (await this.services.externalLinks).openForgotPassword();
        }

    }

}